import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import { store } from '@/store'
import ContentService from '@/services/content'
import env from './env'

let router

Vue.use(VueRouter)

function getRouter () {
  if (router) return router

  const originalPush = VueRouter.prototype.push

  VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
      if (err.name === 'NavigationDuplicated') scroll(0)
      else throw err
    })
  }

  const softLoginAllowedPaths = [
    routes.internal.quickInvoice.path,
    routes.internal.submitInvoice.path,
    routes.internal.notfound.path,
    routes.internal.consent.path
  ]

  router = new VueRouter({routes: Object.values(routes.internal)})
  router.beforeEach((to, from, next) => {
    store.commit('setRecentRoute', to.path)

    if (parseInt(process.env.VUE_APP_USE_UNIVERSAL_LINKS) && (env.isAndroid || env.isIos) && to.meta && to.meta.redirectToApp && to.path && from.name !== null) {
      let location = document.location.href.split('#')

      document.location = 'https://app.agila.de/#' + to.path + '?base=' + location[0]
    }
    // check if route is public
    if (!store.getters['user/loggedIn'] && (!to.meta || !to.meta.public)) {
      // redirect to login route
      next({
        path: routes.internal.login.path,
        query: {
          unauthorized: to.path
        }
      })
    }
    // check if logged in user needs to be redirected
    else if (to.meta.redirectLoggedIn && store.getters['user/loggedIn']) {
      const route = routes.internal[to.meta.redirectLoggedIn]

      // redirect to route or not found route
      next(route ? route.path : routes.internal.notfound.path)
    }
    // soft-login sessions are restricted to the invoice submission flow
    else if (store.getters['user/isSoftLogin'] && !softLoginAllowedPaths.includes(to.path)) {
      next({ path: routes.internal.submitInvoice.path })
    } else {
      next()
    }
  })

  return router
}

async function loadPages (r) {
  store.commit('setPagesLoaded', false)
  
  try {
    const result = await ContentService.getPages()

    result.data
    .filter(page => page.platform.includes(env.platform))
    .forEach(page => {
      r.addRoute({
        component: () => import('../views/Managed'),
        path: '/page' + page.path,
        props: () => ({
          data: page
        }),
        meta: {
          title: page.title,
          public: true,
          icon: page.icon === '0' ? '' : ('agila:' + page.icon)
        }
      })
    })
  
    store.commit('setPagesLoaded', true)
  } catch (error) {
    if (error.handler) {
      error.handler()
    }
  }
}

function scroll (pos) {
  const view = document.getElementById('MainScrollView')

  if (view) {
    view.scrollTop = pos
  }
}

export {
  getRouter,
  loadPages,
  scroll
}